import React from 'react'
import styled from 'styled-components'

const StyledGameWon = styled.div`
    font-family: player2;
`

const GameWon = (): JSX.Element => {
  return (
        <StyledGameWon>
            Congrats you beat PokeConnections!
            <p>
                Refresh to play again
            </p>
        </StyledGameWon>
  )
}

export default GameWon
